import React from 'react';
import { useLocale, useTranslations } from 'next-intl';
import track from '@helper/tracking';
import Form from '../../molecules/form/form';
import newsletterGerman from './data/00-newsletter';
import newsletterEnglish from './data/01-newsletter-en';

const newsletterData = {
  de: newsletterGerman,
  en: newsletterEnglish
};

const NewsletterForm = () => {
  const t = useTranslations();
  const locale = useLocale();
  return (
    <Form
      {...newsletterData[locale]}
      successMessage={t('form.newsletterSuccess')}
      onSubmit={() => {
        track(['trackEvent', 'Newsletter', 'Signup', locale]);
      }}
    />
  );
};

export default NewsletterForm;
